import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useSidebarsContext } from "../../../../context/SidebarsProvider";
import { USER_ROLES } from "../../../../constants/userRoles";
import { paths } from "../../../../utils/paths";
import NormalText from "../../../Typography/NormalText";
import NotificationContentContainer from "./NotificationContentContainer";
import { Button } from "components";
const requestTypeTranslationKeys = {
  Pending: "ReceivedJoin",
  Accepted: "Accepted",
  Rejected: "Rejected",
};

const RequestNotificationContent = ({ notification }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { closeSidebar } = useSidebarsContext();
  const { user, request, field } = notification || {};
  const { status } = request || {};

  const requestTypeTranslationKey = requestTypeTranslationKeys[status];
  const requestTranslationKey = `Inbox.Request.${requestTypeTranslationKey}`;

  const handleClick = () => {
    let requestType = "";

    if (request?.status === "Pending") {
      // If it is pending, it means the user has received a request
      requestType = "received";
    } else {
      // if it is accepted/rejected, it means the user had sent a request
      requestType = "sent";
    }
    if (request?.id && user && requestType) {
      let pathBase = "";
      if (user?.role === USER_ROLES.FARMER) {
        pathBase = paths.farmers.index;
      } else if (user?.role === USER_ROLES.AGRONOMIST) {
        pathBase = paths.agronomists.index;
      }
      if (pathBase) {
        navigate(
          `${pathBase}?requestId=${request.id}&requestType=${requestType}`
        );
        closeSidebar();
      }
    }
  };

  return (
    <NotificationContentContainer
      notification={notification}
      onClick={handleClick}
    >
      <NormalText>
        <Trans
          i18nKey={requestTranslationKey}
          values={{
            userName: user.firstName + " " + user.lastName,
            fieldName: field?.name,
          }}
          components={{
            navlink: <strong />,
          }}
        />
      </NormalText>
      <div className="buttons">
        {/* {totalRequests && totalRequests > 1 && (
          <>
            <Button>{t("Inbox.View")}</Button>
            <Button variant="filled">{t("Inbox.View")}</Button>
          </>
        )} */}
        {/* {totalRequests && totalRequests === 1 && ( */}
        <Button variant="filled">{t("Inbox.View")}</Button>
        {/* )} */}
      </div>
    </NotificationContentContainer>
  );
};

export default RequestNotificationContent;
